/******************************************************************
 * Archivo : client/src/components/Admin/users/EditUser.js
 * Proyecto: CB30
 ******************************************************************/

import React, { Component } from "react";
import { graphql, compose } from "react-apollo";

// Queries
import fetchUserById from "../../../queries/fetchUserById";
import fetchAllRoles from "../../../queries/fetchAllRoles";
import fetchAllUsers from "../../../queries/fetchAllUsers";


// Mutation
import updateUser from "../../../mutations/updateUser";
import createUser from "../../../mutations/createUser";


// Component
import UserForm from "./UserForm";

class EditUser extends Component {

state = {
  msg: "",

  user: {
    active: true,
    validated: false,
    tipoPerfil: 0
  }
};

  componentDidUpdate(prevProps) {

if (
  this.props.fetchUser &&
  this.props.fetchUser.userById &&
  (
    !prevProps.fetchUser ||
    prevProps.fetchUser.userById !== this.props.fetchUser.userById
  )
)
 {

      const user = this.props.fetchUser.userById;

        this.setState({

        user: {

          email: user.email,
          nombre: user.nombre,
          apellido: user.apellido,
          active: user.active,
          validated: user.validated,
          tipoPerfil: user.tipoPerfil,
          roleId:
            user.roles && user.roles.length
              ? user.roles[0].id
              : ""

        }

      });

    }

  }

  handleChange = e => {

    const { name, value, type, checked } = e.target;

    this.setState({

      user: {

        ...this.state.user,

        [name]:
          type === "checkbox"
            ? checked
            : value

      }

    });

  };

handleSubmit = async e => {

  e.preventDefault();

  if (
  this.state.user.password !== this.state.user.confirmPassword
) {

  alert("Las contraseñas no coinciden.");

  return;

}

  const variables = {
    ...this.state.user
  };


  if (this.props.match.params.id) {

  try {

    await this.props.updateUser({

      variables: {

        id: this.props.match.params.id,

        ...variables

      }

    });

    await this.props.fetchUser.refetch();

    this.setState({
      msg: "Usuario actualizado correctamente."
    });

  } catch (error) {

    console.error("ERROR UPDATE USER:", error);

    this.setState({
      msg: "Debe asignar un rol al usuario antes de validarlo."
    });

    return;
  }

} else {

   try {

  const resultado = await this.props.createUser({

  variables,

  refetchQueries: [
    {
      query: fetchAllUsers
    }
  ],

  awaitRefetchQueries: true

});

  console.log("RESULTADO CREATE:", resultado);

} catch (error) {

  console.log("ERROR CREATE:", error);

}

    this.setState({
      msg: "Usuario creado correctamente."
    });

  }

  setTimeout(() => {

    this.props.history.push("/admin/usuarios");

  }, 2000);

};

  render() {

   const isNewUser = !this.props.match.params.id;

if (this.props.fetchAllRoles.loading) {
  return <div className="loader">Loading...</div>;
}

if (!isNewUser && this.props.fetchUser.loading) {
  return <div className="loader">Loading...</div>;
}

return (

  <div className="container">

    <UserForm
  user={this.state.user}
  roles={this.props.fetchAllRoles.roles}
  onChange={this.handleChange}
  onSubmit={this.handleSubmit}
  isNewUser={!this.props.match.params.id}
/>

    <br />

    {
      this.state.msg !== "" &&

      <div className="alert alert-success">
        {this.state.msg}
      </div>
    }

  </div>

);

  }

}

export default compose(

 graphql(fetchUserById, {
  name: "fetchUser",

  skip: props => !props.match.params.id,

  options: props => ({
    variables: {
      id: props.match.params.id
    }
  })
}),

  graphql(fetchAllRoles, {
    name: "fetchAllRoles"
  }),

  graphql(updateUser, {
  name: "updateUser"
}),

graphql(createUser, {
  name: "createUser"
})

)(EditUser);


// WEBPACK FOOTER //
// ./src/components/Admin/users/EditUser.js